import React, { useRef, useState, useContext } from 'react';
import { Link, useLocation, useNavigate } from "react-router-dom";
import NoteContext from '../context/note/NoteContext.js';

const Navbar = (props) => {
    const ref = useRef(null);
    const refClose = useRef(null);
    const [userData, setUserData] = useState({ _id: "", name: "", email: "", timeStamp: "", admin: 0 });
    const [credentials, setCredentials] = useState({ epassword: "" });
    const navigate = useNavigate();
    const context = useContext(NoteContext);
    const { mode, setMode, settextColor, setBackgroundColor, backgroundColor, textColor } = context;

    const onChange = (e) => {
        setCredentials({ ...credentials, [e.target.name]: e.target.value });
    };

    const handleChangepass = async () => {
        const isConfirmed = window.confirm("Are you sure you want to change the Password?");
        if (!isConfirmed) {
            return;
        }
        const { _id } = userData;  // Get the user ID from userData
        const password = credentials.epassword;  // Get the new password
        refClose.current.click();

        // console.log("User ID for password change:", _id, typeof _id);

        // Check if _id is not null or undefined and is a string
        if (!_id || typeof _id !== 'string') {
            console.error("Invalid ID format. Expected a string.");
            return;
        }

        try {
            const response = await fetch(`${props.URI}/api/auth/changepassword/${_id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "auth-token": localStorage.getItem("token"),
                },
                body: JSON.stringify({ password }),
            });

            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }

            // const json = await response.json();
            // console.log(json);

            // Optionally clear the password field after successful change
            setCredentials({ epassword: "" });
            props.showAlert("success", "Password Changed Successfully");

            console.log("Password updated");
        } catch (error) {
            console.error("Error changing password:", error);
        }
    };

    const handleChange = () => {
        console.log("clicked")
        if (mode.backgroundColor === "#77737a") {
            setMode({ backgroundColor: "black" })
            document.body.style.backgroundColor = "Black"
            settextColor({ color: "white" })
            setBackgroundColor({ backgroundColor: "#353535" })
        }
        else {
            setMode({ backgroundColor: "#77737a" });
            document.body.style.backgroundColor = "#77737a"
            settextColor({ color: "black" })
            setBackgroundColor({ backgroundColor: "lavenderblush" })
        }
    }

    const profile = async () => {
        // console.log("profile");
        ref.current.click();
        const response = await fetch(`${props.URI}/api/auth/getUser`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "auth-token": localStorage.getItem("token"),
            },
        });
        const json = await response.json();
        // console.log(json);
        setUserData(json);
    };

    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const [dark, setDark] = useState(false)

    const toggleDark = () => {
        setDark(!dark);
    };

    let location = useLocation();
    const logout = () => {
        localStorage.removeItem("token");
        navigate("/login");
        props.showAlert("success", "Logout Successfully");
    };

    return (
        <>
            <nav className="navbar p-0 pt-0 bg-dark w-100 position-fixed" style={{ zIndex: "10" }}>
                <Link className="navbar-brand mx-3 text-white cinzel" to={`${localStorage.getItem("token") ? ("/home") : ("/")}`}>e-Notebook</Link>

                <div className='d-flex'>
                    <Link className="mx-3 text-white" to="/home">
                        {localStorage.getItem("token") ? (<i className="fa-solid fa-house"></i>) : (" ")}
                    </Link>


                    <div onClick={handleChange}>
                        <i className={`mx-3 text-white ${dark ? 'fa-solid fa-sun' : 'fa-solid fa-moon'}`} onClick={toggleDark}></i>
                    </div>


                    {!localStorage.getItem("token") ? (
                        <span className="d-flex">
                            <Link className="mx-2 text-white" to="/login"><i className="fa-solid fa-right-to-bracket"></i></Link>
                            <Link className="mx-3 text-white" to="/signup"><i className="fa-solid fa-user-plus"></i></Link>
                        </span>
                    ) : (
                        <div>
                            <b onClick={profile} style={{ color: "white", cursor: "pointer" }}><i className="fa-regular fa-user mx-3"></i></b>
                            <b onClick={logout} style={{ color: "white", cursor: "pointer" }}><i className="fa-solid fa-right-from-bracket mx-3"></i></b>
                        </div>
                    )}
                </div>

            </nav>

            {/* Modal for User Profile */}
            <button ref={ref} type="button" className="btn btn-dark d-none" data-bs-toggle="modal" data-bs-target="#exampleModal2">
                Launch demo modal
            </button>

            <div className="modal fade" id="exampleModal2" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content" style={{ ...backgroundColor, ...textColor }}>
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabel">Profile</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="container mt-2">
                                <h2>User Details</h2>
                                <table className="table table-bordered table-striped">
                                    <tbody>
                                        <tr>
                                            <th scope="row" style={{ ...backgroundColor, ...textColor }}>User ID</th>
                                            <td style={{ ...backgroundColor, ...textColor }}>{userData._id}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" style={{ ...backgroundColor, ...textColor }}>Name</th>
                                            <td style={{ ...backgroundColor, ...textColor }}>{userData.name}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" style={{ ...backgroundColor, ...textColor }}>Email address</th>
                                            <td style={{ ...backgroundColor, ...textColor }}>{userData.email}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" style={{ ...backgroundColor, ...textColor }}>Account Created Time</th>
                                            <td style={{ ...backgroundColor, ...textColor }}>{userData.timeStamp}</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <h4 className="container mt-2">Change Password</h4>
                                <table className="table table-bordered table-striped">
                                    <tbody>
                                        <tr style={{ height: '100px' }}>
                                            <th scope="row" className="align-middle" style={{ ...backgroundColor, ...textColor }}>New Password</th>

                                            <td style={{ ...backgroundColor, ...textColor }}>
                                                <input type={showPassword ? 'text' : 'password'} className="form-control" style={{ paddingRight: "35px" }} id="epassword" name='epassword' value={credentials.epassword} onChange={onChange} required />

                                                <span className="mx-2" style={{ position: "absolute", marginTop: "-31px", right: "38px" }} onClick={togglePasswordVisibility}>
                                                    <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'} text-black`}></i>
                                                </span>

                                                <div className='d-flex justify-content-center'>
                                                    <button disabled={credentials.epassword.length < 6} type="button" className="btn btn-dark my-2" style={{borderRadius: "20px"}} onClick={handleChangepass}>Update Password</button>
                                                </div>

                                            </td >
                                        </tr >
                                        {
                                            userData.admin === 1 && <tr>
                                                <th scope="row" className="align-middle" style={{ ...backgroundColor, ...textColor }}>Admin</th>
                                                <td style={{ ...backgroundColor, ...textColor }}>
                                                    <Link className={`${location.pathname === "/admin"}`} to="/admin"><button className='btn btn-dark'>Admin</button></Link>
                                                </td>
                                            </tr>
                                        }
                                    </tbody >
                                </table >
                            </div >


                        </div >
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" ref={refClose}>Close</button>
                        </div>
                    </div >
                </div >
            </div >
        </>
    );
}

export default Navbar;
